/**
 * 航线维护枚举定义
 */

/** 枚举项接口 */
interface EnumItem {
  value: string
  label: string
  labelEn: string
}

interface EnumNumberItem {
  value: number
  label: string
  labelEn: string
}

export const BelongingAllianceEnum = {
  TWO_M_ALLIANCE: {
    value: 1,
    label: '2M联盟',
    labelEn: '2M Alliance'
  },
  OCEAN_ALLIANCE: {
    value: 2,
    label: '海洋联盟',
    labelEn: 'Ocean Alliance'
  },
  THE_ALLIANCE: {
    value: 3,
    label: 'THE联盟',
    labelEn: 'THE Alliance'
  },
  INDEPENDENT_OPERATION: {
    value: 4,
    label: '独立运营',
    labelEn: 'Independent Operation'
  }
} as const

/** 星期枚举 */
export const WeekdayEnum = {
  MONDAY: {
    value: '1',
    label: '周一',
    labelEn: 'Monday'
  },
  TUESDAY: {
    value: '2',
    label: '周二',
    labelEn: 'Tuesday'
  },
  WEDNESDAY: {
    value: '3',
    label: '周三',
    labelEn: 'Wednesday'
  },
  THURSDAY: {
    value: '4',
    label: '周四',
    labelEn: 'Thursday'
  },
  FRIDAY: {
    value: '5',
    label: '周五',
    labelEn: 'Friday'
  },
  SATURDAY: {
    value: '6',
    label: '周六',
    labelEn: 'Saturday'
  },
  SUNDAY: {
    value: '7',
    label: '周日',
    labelEn: 'Sunday'
  }
} as const

/** 工具函数：将枚举对象转换为选项数组 */
export const enumToOptions = (enumObj: Record<string, EnumItem>) => {
  return Object.values(enumObj).map(item => ({
    label: item.label,
    value: item.value
  }))
}

/** 工具函数：将枚举对象转换为英文选项数组 */
export const enumToEnOptions = (enumObj: Record<string, EnumItem>) => {
  return Object.values(enumObj).map(item => ({
    label: item.labelEn,
    value: item.value
  }))
}

/** 工具函数：根据value获取枚举项 */
export const getEnumItemByValue = (enumObj: Record<string, EnumItem>, value: string) => {
  return Object.values(enumObj).find(item => item.value === value)
}

/** 工具函数：根据value获取label */
export const getEnumLabelByValue = (enumObj: Record<string, EnumItem>, value: string) => {
  const item = getEnumItemByValue(enumObj, value)
  return item?.label || value
}

/** 工具函数：根据value获取英文label */
export const getEnumEnLabelByValue = (enumObj: Record<string, EnumItem>, value: string) => {
  const item = getEnumItemByValue(enumObj, value)
  return item?.labelEn || value
}


/** 工具函数：将枚举对象转换为选项数组 */
export const enumToOptionsNumber = (enumObj: Record<number, EnumNumberItem>) => {
  return Object.values(enumObj).map(item => ({
    label: item.label,
    value: item.value
  }))
}

/** 工具函数：将枚举对象转换为英文选项数组 */
export const enumToEnOptionsNumber = (enumObj: Record<number, EnumNumberItem>) => {
  return Object.values(enumObj).map(item => ({
    label: item.labelEn,
    value: item.value
  }))
}

/** 工具函数：根据value获取label */
export const getEnumLabelByNumberValue = (enumObj: Record<number, EnumNumberItem>, value: number) => {
  const item = Object.values(enumObj).find(item => item.value === value)
  return item?.label || value
}

/** 工具函数：根据value获取英文label */
export const getEnumEnLabelByNumberValue = (enumObj: Record<number, EnumNumberItem>, value: number) => {
  const item = Object.values(enumObj).find(item => item.value === value)
  return item?.labelEn || value
}
export const BelongingAllianceEnumKey = {
  TWO_M_ALLIANCE: 1, // 2M联盟
  OCEAN_ALLIANCE: 2, // 海洋联盟
  THE_ALLIANCE: 3, // THE联盟
  INDEPENDENT_OPERATION: 4 // 独立运营
}
